import { render } from "./Panel3.vue?vue&type=template&id=3aef8707&scoped=true"
import script from "./Panel3.vue?vue&type=script&lang=js"
export * from "./Panel3.vue?vue&type=script&lang=js"

import "./Panel3.vue?vue&type=style&index=0&id=3aef8707&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aef8707"]])

export default __exports__